import { gql } from '@apollo/client';

export const queryGetJobKeywordSuggestionsV2 = gql`
  query getJobTitleSuggestions(
    $keyword: String!
    $countryCode: String
    $limit: Int
  ) {
    getJobTitleSuggestions(
      keyword: $keyword
      countryCode: $countryCode
      limit: $limit
    ) {
      jobTitles
      count
      expInfo
    }
  }
`;
